/**
 * MFA Setup Page for Admin Console
 *
 * Delegates to the Account Region (AR), the canonical identity provider
 * for MFA enrollment. The shared AuthGuard redirects to AR for setup
 * when MFA is not configured; this page is a safety net.
 */

import { useEffect } from "react";
import { getIdentityBrowserUrl } from "shared/lib/identity-client";

export function MfaSetupPage() {
  useEffect(() => {
    const returnTo = new URLSearchParams(window.location.search).get("return_to") || window.location.origin + "/";
    window.location.href = `${getIdentityBrowserUrl()}/auth/mfa/setup?return_to=${encodeURIComponent(returnTo)}`;
  }, []);

  return null;
}

export default MfaSetupPage;
